import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '爱情岛一论坛免费路线是否安全可靠？',
    a: '本站整理的所有路线均经过严格验证，确保来源安全可靠。建议通过本站提供的官方推荐路线进行访问，避免使用来源不明的第三方链接。我们会持续监控路线状态，及时更新最新可用入口。',
  },
  {
    q: '如何选择最适合自己的访问路线？',
    a: '建议根据你的网络环境和地理位置选择路线。一般来说，优先使用主路线，速度最快稳定性最高；如果主路线不可用，可以尝试备用路线或镜像站点。可以收藏多个路线以备不时之需。',
  },
  {
    q: '访问路线多久更新一次？',
    a: '我们会每日检查路线可用状态，一旦发现路线不可用会第一时间更新。常规情况下每周会发布路线状态报告，遇到重大变更时会在当天更新。建议收藏本站并定期查看最新路线信息。',
  },
  {
    q: '手机端和电脑端访问有什么区别？',
    a: '手机端和电脑端的访问方式基本一致，但手机端可能需要针对移动网络进行额外优化。本站提供专门的手机端访问教程，涵盖iOS和Android两大平台，可按需查看。',
  },
  {
    q: '路线突然无法访问怎么办？',
    a: '如果当前路线无法访问，首先尝试刷新页面或清除浏览器缓存。如果问题依旧，切换至本站提供的备用路线。如仍无法解决，请查看常见问题页面或联系我们获取帮助。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-base">
            关于论坛访问路线和使用的最常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center rounded-full bg-background-200 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-sm text-foreground-600"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100 pb-5 px-5' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/faq"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看更多常见问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}